const initialValue = { estSched: '', qty: '' }

export default initialValue
